import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { IntlProvider } from "react-intl";
import { getUserAudience } from "@repo/utils";
import { getAppLocale } from "./lang";

const { country, lang: langCode } = getUserAudience();
const appLocale = getAppLocale(country, langCode);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <IntlProvider
      locale={appLocale.locale}
      formats={appLocale.format}
      messages={appLocale.translations}
    >
      <App />
    </IntlProvider>
  </React.StrictMode>,
);
